import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cloneDeep } from 'lodash';
import TableComponent from 'components/table-component-new/Table';
import TablePagination from 'components/table-component-new/TablePagination';
import { archivedTasksHeaderList } from '../utils';
import { CallAPI } from 'actions/General';
import ArchivedTaskListHeader from './ArchivedTaskListHeader';

const ArchivedTaskList = () => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [displayEntries, setDisplayEntries] = useState(10);
  const [selectedRows, setSelectedRows] = useState([]);
  const [taskList, setTaskList] = useState([]);
  const [filter, setFilter] = useState({});

  const handleDebouncedFilter = (name, value) => {
    setFilter((prev) => ({ ...prev, [name]: value }));
  };

  const actionsCallBack = async (action, data) => {
    if (action === 'restore') {
      const payload = { taskIds: data.ids, state: 'active' };
      const result = await CallAPI('UPDATE_TASKS_STATE', payload);
      if (result.status) {
        fetchTaskList();
      }
    } else if (action === 'delete') {
      const payload = { taskIds: data.ids };
      const result = await CallAPI('DELETE_BULK_TASKS', payload);
      if (result.status) {
        fetchTaskList();
      }
    }
  };

  const fetchTaskList = async (page = currentPage, limit = displayEntries) => {
    setSelectedRows([]);
    const payload = { state: 'archived', page, limit };
    if (filter.search) payload.searchText = filter.search;

    const result = await CallAPI('GET_ALL_TASKS', payload, null, setLoading);
    if (result.status) {
      result.data.list.forEach((t) => {
        t.displayRefNumber = `TK-${t.referenceNumber}`;
        t.formTitle = t.form.title;
        t.companyFieldName = t.companyField?.fieldTitle ?? '';
      });
      setTaskList(result.data.list);
      setTotalRecords(result.data.count);
    }
  };

  const onRowsSelection = (name, value) => {
    if (name === 'all') {
      const selectedRecords = [];
      if (value)
        taskList.forEach((s) => {
          selectedRecords.push({ id: s._id });
        });
      setSelectedRows(selectedRecords);
    } else {
      let tempSelection = cloneDeep(selectedRows);
      if (value) tempSelection.push({ id: name });
      else tempSelection = tempSelection.filter((s) => s.id !== name);
      setSelectedRows(tempSelection);
    }
  };

  useEffect(() => {
    fetchTaskList();
  }, [filter]);

  return (
    <div>
      <div className='d-flex gap-1 flex-column'>
        <label className='theme-size-2 theme-text-black-1'>{t('text_archived_task')}</label>
        <label>{t('text_archived_task_description')}</label>
      </div>
      <ArchivedTaskListHeader
        handleDebouncedFilter={handleDebouncedFilter}
        selectedRows={selectedRows}
        actionsCallBack={actionsCallBack}
      />
      <TableComponent
        header={archivedTasksHeaderList}
        data={taskList}
        props={{
          translateValueFunc: (val) => t(val),
        }}
        totalRecords={totalRecords}
        loader={loading}
        isFieldSelectionEnabled={false}
        isActionsEnabled={false}
        isSelectionEnabled={true}
        selectionKey={'_id'}
        onSelection={onRowsSelection}
        selectedRows={selectedRows}
        headerCellBorder='vertical'
        bodyCellBorder='both'
      />

      {totalRecords > 0 && (
        <TablePagination
          totalRecords={totalRecords}
          currentPageRecords={taskList.length}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          displayEntries={displayEntries}
          setDisplayEntries={setDisplayEntries}
          listingFunction={fetchTaskList}
        />
      )}
    </div>
  );
};

export default ArchivedTaskList;
